import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './CheckButton.themes';
type Props = {
  children: Node;
  className?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
  theme?: keyof typeof themes;
};
export const CheckButton = ({
  children,
  className,
  isChecked,
  isDisabled,
  onClick,
  theme = 'default',
}: Props) => {
  const { thIcon, thIconWidth, thRoot } = themes[theme]({
    isChecked,
    isDisabled,
  });
  return (
    <button
      aria-checked={isChecked}
      aria-disabled={isDisabled}
      className={classnames(thRoot, className)}
      onClick={!isDisabled && onClick}
      role="checkbox"
      type="button"
    >
      {isChecked && <Icon className={thIcon} name={ICONS.CHECK} width={thIconWidth} />}
      {children}
    </button>
  );
};
